import React, { useState } from "react";
import "tailwindcss/tailwind.css";
import { Edit, Trash, File } from 'tabler-icons-react';
import { Select, TextInput, Button, Table, ActionIcon } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import useMultiFileUpload from "../../hooks/useMultiFileUpload";
import NewDocumentUploader from "../../components/NewDocumentUploader/NewDocumentUploader";
import AddInvoiceModal from "../../components/Recovery/AddInvoiceModal";
import InvoiceListSection from "../../components/Recovery/InvoiceListSection";
import { formatDate, formatNumberWithCommas } from "../../utilities/utilities";

const DueDetailPage = ({ formState, setFormState, errors }) => {
  // const multiUploadArgs = useMultiFileUpload({ parent: 'recoveryRecord', parentId: id });
  console.log("DueDetailPage -> formState", formState);
  const [invoiceData, setInvoiceData] = useState({
    isModalOpen: false,
    isEdit: false,
    id: 0,
    number: "",
    date: "",
    amount: "",
    currencyType: "INR",
    creditPeriod: "",
    files: "",
    penaltyRate: 0,
    errors: {},
  });
  const multiUploadArgs = useMultiFileUpload({
    loadFromParent: true,
    parent: "dueDetail",
    parentId: formState.id,
  });
  formState.files = multiUploadArgs.finalFiles;

  return (
    <>
      <AddInvoiceModal
        formState={invoiceData}
        setFormState={setInvoiceData}
        dueDetailFormState={formState}
        setDueDetailFormState={setFormState}
        errors={invoiceData.errors}
      />
      {/* <div className="grid grid-cols-4 gap-4 my-4 m-10 mt-10">
        <TextInput
          required
          disabled
          label="Recovery Amount"
          type="number"
          value={formState.recoveryAmount}
          onChange={(event) => {
            const newValue = event.currentTarget.value;
            setFormState((prevState) => ({
              ...prevState,
              recoveryAmount: newValue,
            }));
          }}
          error={errors.recoveryAmount}
        />
        <Select
          required
          disabled
          className="inputCustom w-full ml-0 leading-normal"
          label="Currency Type"
          data={[
            { value: "INR", label: "INR" },
            { value: "USD", label: "USD" },
          ]}
          value={formState.currencyType}
          onChange={(value) => {
            setFormState((prevState) => ({
              ...prevState,
              currencyType: value,
            }));
          }}
          error={errors.currencyType}
        />
        <DatePicker
          required
          disabled
          label="First Invoice"
          value={formState.firstInvDate}
          onChange={(value) => {
            setFormState((prevState) => ({
              ...prevState,
              firstInvDate: value,
            }));
          }}
          error={errors.firstInvDate}
        />
        <TextInput
          required
          disabled
          type="number"
          label="No. of Invoices"
          value={formState.noOfInvoice}
          onChange={(event) => {
            const newValue = event.currentTarget.value;
            setFormState((prevState) => ({
              ...prevState,
              noOfInvoice: newValue,
            }));
          }}
          error={errors.noOfInvoice}
        />
      </div> */}

      <div className="grid grid-cols-4 gap-y-9 gap-x-4 mt-5 mb-5 m-8">
        <div>
          <div className="font-light text-[16px] leading-[1.55] text-[#595A5B]">
            recovery amount
          </div>
          <div className="font-normal text-[14px] leading-[1.55] text-[#121212]">
            {formatNumberWithCommas(formState.recoveryAmount)}
          </div>
        </div>
        <div>
          <div className="font-light text-[16px] leading-[1.55] text-[#595A5B]">
            currency type
          </div>
          <div className="font-normal text-[14px] leading-[1.55] text-[#121212]">
            {formState.currencyType}
          </div>
        </div>
        <div>
          <div className="font-light text-[16px] leading-[1.55] text-[#595A5B]">
            first invoice
          </div>
          <div className="font-normal text-[14px] leading-[1.55] text-[#121212]">
            {formatDate(formState.firstInvDate)}
          </div>
        </div>
        <div>
          <div className="font-light text-[16px] leading-[1.55] text-[#595A5B]">
            no. of invoices
          </div>
          <div className="font-normal text-[14px] leading-[1.55] text-[#121212]">
            {formState.noOfInvoice}
          </div>
        </div>
      </div>

      <InvoiceListSection dueDetailId={formState.id} invoiceData={invoiceData} setInvoiceData={setInvoiceData} setDueDetail={setFormState} />
      <div className="flex justify-center mt-8">
        <Button
          // color="green"
          onClick={() => {
            setInvoiceData((prevState) => ({
              ...prevState,
              isModalOpen: true,
            }));
          }}
        >
          add invoice
        </Button>
      </div>
      <div className="m-10">
        <NewDocumentUploader key={88} multiUploadArgs={multiUploadArgs} />
      </div>
    </>
  );
};

export default DueDetailPage;
